export default "__VITE_ASSET__BngqgCD6__"